export default {
    container: {
        width: "max-content",
        display: "inline-block",
        cursor: "pointer"
    }
}